module.exports = __webpack_public_path__ + "img/logo-school-1.15e565b8.png";